import {
  dealerService
}
from '../services';

import PrepareFilter from '../utils/PrepareFilter';
import config from '../Config';

const state = {
  status: {},
  country: 'DE',
  step: 0,
  topic: 0,
  topics: [],
  formsetting: null,
  settings: [],
  info: '',
  locationVehicleListScrollPosition: 0,
  dealerVehicleListScrollPosition: 0,

};

const actions = {

  async contactConfig(state) {

      await dealerService.loadConfig()
        .then(
          data => {
            if (!data) {
              this.commit('loadConfigFailure');
            } else {

              this.commit('summery/loadConfigSuccess', data);
            }
          },
          error => {
            this.dispatch('summery/error', error, {
              root: true
            });
          }
        );

      return true
    },
    async info(state, lang) {

      await dealerService.loadRewacoInfo(lang)
        .then(
          data => {
            console.log(data);
            if (!data) {
              this.commit('loadInfoFailure');
            } else {

              this.commit('summery/loadInfoSuccess', data);
            }
          },
          error => {
            this.dispatch('summery/error', error, {
              root: true
            });
          }
        );

      return true
    },
    async recordContactEmail(state, request) {

      return dealerService.recordContactEmail(request.email,
        request.lang);

    },
    async confirmContactEmail(state, requestid) {


      return dealerService.confirmContactEmail(requestid);

    },
    async confirmRequest(state, requestid) {

      return dealerService.confirmRequest(requestid);

    },
    async error(state, error) {
      console.log("Error");

    }
};

function mapImages(i) {
  return Promise.all(i.map((image) => {
    return {
      src: config.filedelivery + image,
      org: image
    };
  }));
}
const mutations = {
  async loadConfigSuccess(state, config) {
      console.log(config);
      state.settings = config;
    },
    async loadInfoSuccess(state, info) {
      state.info = info.info;
    },
    address(state, address) {
      state.address = address
    },
    step(state, step) {
      state.step = step
    },
    formsetting(state, setting) {
      state.formsetting = setting
    }

};

const getters = {}

export const summery = {
  namespaced: true,
  state,
  actions,
  mutations
};
